module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-SURVEYMONKEY.bef3fce8.png";